import {
  integrationHasCustomizableAdminMappingSettings,
  integrationHasPredefinedAdminMappingSettings,
  IntegrationServiceId,
} from '../../../../common/integrations'
import { useIntegrations } from '../../useIntegrations'
import { useCustomizableAdminSettings } from './CustomizableAdminSettings'
import { useMemo } from 'react'
import { usePredefinedAdminSettings } from './PredefinedAdminSettings'
import { useEMoneyAdminSettings } from './eMoney/EMoneyAdminSettings'
import { ClickNavigationSection } from '../../../../components/NavigationWithSideBar/ClickNavigation'
import { GeneralAdminSettings } from './AdminSettingsTabs/General/GeneralAdminSettings'

export const useIntegrationSpecificAdminSections = (serviceId: IntegrationServiceId) => {
  const customizableSections = useCustomizableAdminSettings(serviceId)

  const predefinedSections = usePredefinedAdminSettings(serviceId)

  const eMoneyAdminSections = useEMoneyAdminSettings()

  const { supportsContactCreate, supportsContactUpdate, isLoading: isIntegrationsLoading } = useIntegrations()

  const settingsSections = useMemo<ClickNavigationSection[]>(
    () =>
      supportsContactCreate(serviceId) || supportsContactUpdate(serviceId)
        ? [{ id: 'settings', label: 'Settings', content: () => <GeneralAdminSettings serviceId={serviceId} /> }]
        : [],
    [serviceId, supportsContactCreate, supportsContactUpdate],
  )

  const sections = useMemo(() => {
    if (integrationHasCustomizableAdminMappingSettings(serviceId)) {
      return customizableSections
    }
    if (integrationHasPredefinedAdminMappingSettings(serviceId)) {
      return predefinedSections
    }
    if (serviceId === IntegrationServiceId.E_MONEY) {
      return [...settingsSections, ...eMoneyAdminSections]
    }
    return settingsSections
  }, [serviceId, customizableSections, predefinedSections, eMoneyAdminSections, settingsSections])

  return { sections, isLoading: isIntegrationsLoading }
}
